export default "__VITE_ASSET__BUyablRL__"